<template>
  <div id="app">
    <div class="video" v-if="video">
      <video autoplay="true"
             muted="muted"
             loop="loop"
             x5-video-player-fullscreen="true"
             x5-video-player-type="h5"
             playsinline="true"
             webkit-playsinline="true"
             :src="videoAddress"
      >
      </video>
      <div class="show_text" @click="toIndexPage" v-html="videoText">
        <div class="text">
          <div>实践是检验真理的唯一标准</div>
          <div>进入官网</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Video",
  data() {
    return {
      videoAddress: '',
      showVideo: true,
      video: true,
      videoText: ''
    }
  },
  mounted() {
    this.getWidth()
    this.getText()
  },

  methods: {
    // 获取文字信息
    getText(){
      axios.get('/back/showText/showText').then(res => {
        this.videoText =  res.data.data.showText
      })
    },
    getWidth() {
      let width = document.documentElement.clientWidth;
      if (width < 1025) {
        this.$router.push({path: '/index/index'})
      } else {
        this.getVideoInfo();
      }
    },
    getVideoInfo() {
      let that = this
      axios.get('/back/video/video').then(res => {
        let flag = res.data.data.videoAble;
        if (!flag) {
          this.$router.push({path: '/index/index'})
        }
        that.videoAddress = res.data.data.videoAddress
      })
      // 将首页地址指向cat游戏
      // window.location.href='https://www.oaimdesign.com/html/html/g.html#cat';
    },
    toIndexPage() {
      this.$router.push({path: '/index/index'})
    }
  }
}
</script>

<style>
.show_text {
  position: absolute;
  left: 0;
  top: 60%;
  transform: translateY(-50%);
  text-align: center;
  width: 100%;
  transition-property: opacity;
  transition-duration: 2s;
  transition-timing-function: ease;
  transition-delay: 0s;
  cursor: pointer;
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.text {
  -webkit-animation: show_text 3s ease;
  -o-animation: show_text 3s ease;
  animation: show_text 3s ease;
  -moz-animation: show_text 3s ease;
  color: white;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
  flex-direction: row;
}

@keyframes show_text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    color: white;
  }
}

@-webkit-keyframes show_text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    color: white;
  }
}

@-o-keyframes show_text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    color: white;
  }
}

@-moz-keyframes show_text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    color: white;
  }
}

.video > video {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

@keyframes bigger {
  0% {
    width: 100%;
  }
  100% {
    width: 96%;
  }
}

@-moz-keyframes bigger {
  0% {
    width: 100%;
  }
  100% {
    width: 96%;
  }
}

@-webkit-keyframes bigger {
  0% {
    width: 100%;
  }
  100% {
    width: 96%;
  }
}

@-o-keyframes bigger {
  0% {
    width: 100%;
  }
  100% {
    width: 96%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/video/Video.vue